import { Layout, SubInterSection as SubInterSectionComponent } from "components"
export const SubInterSection = () => {
 return (
  <Layout>
   <SubInterSectionComponent />
  </Layout>
 )
}
